module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/ghost.png?6436660957b017c30f19422274e11730";